export const setLocal = (name, value) => {
  localStorage.setItem(`${name}Key`, value);
};

export const getLocal = (name, value) => {
  return localStorage.getItem(`${name}Key`);
};

export const clearLocal = () => {
  localStorage.clear();
};
